import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

const PATH_TEMPLATE = '/workflow-reports/report.csv';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['POST'];
type Input = THIS_API['body'];
type Output = THIS_API['response'];

const generateReportCsv = async ({ headers, data }: Input): Promise<Output> => {
  const response = await noodleApiClient.post('/workflow-reports/report.csv', {
    data,
    headers,
  });
  return response.data;
};

export default generateReportCsv;
